import { Alert, Button, FormGroup, Heading, Link, Loader} from 'arag-ui-lib';
import React from 'react';
import SolicitorFirmSearchSelect from '../solicitorFirmSearchSelect';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../helpers/formGroupVariants';
import {
    INITIAL_OPTIONS,
    SELECTED_CASE_TYPE,
    SELECTED_SUB_CASE_TYPE,
    SOLICITOR_FIRM_ID_MN,
    INTERNAL_ALERT_TEXT_MN,
    VALID_FROM_MN,
    VALID_TO_MN,
    DATE_FORMAT_DD_MM_YYYY,
    SUBMIT,
    RIGHT,
    LEFT,
    PRIMARY,
    QUATERNARY,
    TERTIARY,
    HEADING_2,
    SUCCESS,
    ERROR,
} from '../../helpers/constants';
import { LEGAL_ADVICE_TEXT } from '../../helpers/variables';

const InternalAlertForm = (props) => {
    const {
        isEdit,
        solicitorGroup,
        lawsysFirms,
        changeFormData,
        formData,
        handleSubmit,
        user,
        internalAlertForm,
        groups,
        handleDelete,
        goBack
    } = props;
    const isUserAllowed = user.loggedInUser.allowedToCreateInternalAlerts
    const loading = internalAlertForm.posting || internalAlertForm.patching || internalAlertForm.deleting;
    const selectedFirm = formData.solicitorFirm && formData.solicitorFirm.value === formData.solicitorFirmId ? formData.solicitorFirm : null;
    const isLoading = internalAlertForm.fetching ||
                groups.fetchingSolicitorGroupCaseTypes ||
                lawsysFirms.fetchingLawsysFirmGroup ||
                internalAlertForm.solicitorCaseTypes.length == 0
    const caseTypeOptions = [...INITIAL_OPTIONS, ...internalAlertForm.solicitorCaseTypes.map(c => { return { key: c.id, label: c.name } })];
    const subCaseTypeOptions = [{ key: '0', label: CONTENT_STRINGS.NONE }, ...internalAlertForm?.solicitorSubCaseTypes
        .filter(sc => sc?.caseTypeId == formData?.selectedCaseType)
        .map(c => { return { key: c?.id, label: c?.name } })];
        
    return (
        <div className="col-sm-12 applicationsAndPolicies-wrapper">
            {
                isEdit && isLoading
                ? 
                    <Loader variant='list' /> 
                :
                    <form
                        onSubmit={(e) => {
                            e.preventDefault()
                            handleSubmit()
                        }}
                    >
                        <div className="row">
                            <Heading variant={HEADING_2} title={isEdit ? CONTENT_STRINGS.UPDATE_INTERNAL_ALERT : CONTENT_STRINGS.CREATE_NEW_INTERNAL_ALERT} />
                        </div>
                        <SolicitorFirmSearchSelect
                            labelSize={"col-sm-3"}
                            inputSize={"col-sm-6"}
                            label={`${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM} *`}
                            isDisabled={!isUserAllowed}
                            instanceId={"internalAlertFormSolicitorFirm"}
                            onChange={(option) => {
                                changeFormData('solicitorFirm', option || null);
                                changeFormData(SOLICITOR_FIRM_ID_MN, option ? option.value : "");
                            }}
                            value={selectedFirm}
                        />
                        {lawsysFirms.fetchingLawsysFirmGroup && <div className="text-center" >
                            <Loader variant='inline' />
                        </div>
                        }
                        {internalAlertForm.solicitorCaseTypes.length > 0 &&
                            !lawsysFirms.fetchingLawsysFirmGroup &&
                            solicitorGroup != '' &&
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={CONTENT_STRINGS.CASE_TYPE}
                                variant={FORM_GROUP_VARIANTS.SELECT}
                                inputProps={{
                                    required: true,
                                    disabled: !isUserAllowed,
                                    onChange: ((evt) => { changeFormData(evt.target.name, parseInt(evt.target.value)) }),
                                    options: caseTypeOptions,
                                    value: formData.selectedCaseType,
                                    name: SELECTED_CASE_TYPE,
                                }}
                            />
                        }

                        {internalAlertForm.solicitorSubCaseTypes.length > 0 &&
                            formData.selectedCaseType != '' &&
                            internalAlertForm.solicitorSubCaseTypes.some(c => c.caseTypeId == formData.selectedCaseType) &&
                            <FormGroup
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={CONTENT_STRINGS.SUB_CASE_TYPE}
                                variant={FORM_GROUP_VARIANTS.SELECT}
                                inputProps={{
                                    disabled: !isUserAllowed,
                                    onChange: ((evt) => { changeFormData(evt.target.name, parseInt(evt.target.value)) }),
                                    options: subCaseTypeOptions,
                                    value: formData?.selectedSubCaseType,
                                    name: SELECTED_SUB_CASE_TYPE,
                                }}
                            />
                        }
                        {formData.selectedCaseType != '' &&
                            <div>
                                <FormGroup
                                    labelSize={'col-sm-3'}
                                    inputSize={"col-sm-6"}
                                    label={CONTENT_STRINGS.INTERNAL_ALERT}
                                    variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                                    inputProps={{
                                        required: true,
                                        disabled: !isUserAllowed,
                                        onChange: ((evt) => { changeFormData(evt.target.name, evt.target.value) }),
                                        name: INTERNAL_ALERT_TEXT_MN,
                                        value: formData?.internalAlertText,
                                    }}
                                />
                                <FormGroup
                                    labelSize={'col-sm-3'}
                                    inputSize={'col-sm-6'}
                                    label={CONTENT_STRINGS.POLICY_LIVE_DATE_FROM}
                                    variant={FORM_GROUP_VARIANTS.DATE}
                                    inputProps={{
                                        required: true,
                                        name: VALID_FROM_MN,
                                        dateInputProps: {
                                            required: true,
                                            disabled: !isUserAllowed,
                                            onChange: ((evt) => { changeFormData(VALID_FROM_MN, evt) }),
                                            autoComplete: 'off',
                                            dateFormat: DATE_FORMAT_DD_MM_YYYY,
                                            selected: formData?.validFrom,
                                            placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER
                                        },
                                    }}
                                />
                                <FormGroup
                                    labelSize={'col-sm-3'}
                                    inputSize={'col-sm-6'}
                                    label={CONTENT_STRINGS.POLICY_LIVE_DATE_TO}
                                    variant={FORM_GROUP_VARIANTS.DATE}
                                    inputProps={{
                                        name: VALID_TO_MN,
                                        value: formData.validTo,
                                        required: false,
                                        dateInputProps: {
                                            required: false,
                                            disabled: !isUserAllowed,
                                            minDate: formData.validFrom,
                                            dateFormat: DATE_FORMAT_DD_MM_YYYY,
                                            onChange: ((evt) => { changeFormData(VALID_TO_MN, evt) }),
                                            autoComplete: 'off',
                                            selected: formData.validTo,
                                            placeholderText : CONTENT_STRINGS.DATE_PLACEHOLDER
                                        },
                                    }}
                                />
                                <div className='row' style={{ display: 'flex', alignContent: 'center' }} >
                                    <div className='col-xs-offset-3  col-sm-8' style={{ display: 'flex', gap: 10, alignContent: 'center' }}>
                                        {
                                            isUserAllowed
                                            ?
                                                <Button 
                                                    variant={PRIMARY}
                                                    disabled={loading}
                                                    label={CONTENT_STRINGS.SAVE}
                                                    type={SUBMIT}
                                                    btnType={SUBMIT}
                                                    arrowDirection={RIGHT}
                                                />
                                            :
                                                null
                                        }
                                        <Button
                                            variant={QUATERNARY}
                                            label={CONTENT_STRINGS.CANCEL}
                                            arrowDirection={RIGHT}
                                            disabled={loading}
                                            onClick={goBack}
                                        />
                                        {
                                            formData?.id && isUserAllowed 
                                            ?
                                                <div style={{ alignSelf: 'center' }}>
                                                    <Link
                                                        variant={TERTIARY}
                                                        arrowDirection={LEFT}
                                                        disabled={loading}
                                                        label={CONTENT_STRINGS.DELETE}
                                                        onClick={handleDelete}
                                                    />
                                                </div>
                                            :
                                                null
                                        }
                                        {loading ? <Loader variant="inline" /> : null}
                                    </div>
                                </div>

                                {internalAlertForm.response !== '' ? <Alert variant={SUCCESS} label={internalAlertForm.response} /> : null}
                                {internalAlertForm.badResponse !== '' ? <Alert variant={ERROR} label={internalAlertForm.badResponse} /> : null}
                            </div>}
                    </form>}
        </div>
    )
}
export default InternalAlertForm
